import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import { InputField } from 'components/Global';
import React from 'react';
import { setCurrency } from 'utils/functionality';

const DetailVoucher = ({ data }) => {
  const isThirdAnniversaryVoucherEnabled = useFliptBoolean('FLAG_FE_THIRD_ANNIVERSARY_VOUCHER', false, 'anonymous');

  return (
    <div className="detail-order__voucher-detail">
      <div className="detail-order__voucher-detail-title">
        <h1>Voucher</h1>
      </div>
      {isThirdAnniversaryVoucherEnabled && data?.vouchers?.length > 0 ? (
        data.vouchers.map((vou) => (
          <div className="detail-order__voucher-detail-body" key={vou.id} style={{ marginBottom: '42px' }}>
            <InputField label="Nama Voucher" disabled value={vou?.name || '-'} />
            <InputField label="Kode Voucher" disabled value={vou?.code || '-'} />
            <InputField label="Harga Potongan" disabled value={vou?.value ? setCurrency(vou.value) : '-'} />
          </div>
        ))
      ) : (
        <div className="detail-order__voucher-detail-body">
          <InputField label="Nama Voucher" disabled value={data?.vouchers?.[0].name || '-'} />
          <InputField label="Kode Voucher" disabled value={data?.vouchers?.[0].code || '-'} />
          <InputField label="Harga Potongan" disabled value={setCurrency(data?.vouchers?.[0].value) || '-'} />
        </div>
      )}
    </div>
  );
};

export default DetailVoucher;
